import { useState, useEffect } from "react";
import { Form, Input, Select, Button, Tag } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getCity,
  getCountry,
  getLanguage,
  getState,
} from "../../../redux/action/Location";
import { getUserProfile, updateProfile } from "../../../redux/action/Profile";
import Model from "../../Model";
import IMAGES from "../../../constants/images";
import { resetProfileUpdate } from "../../../redux/slice/Profile";
const { Option } = Select;
const { TextArea } = Input;

const RegistrationForm = ({ editActive, setEditActive, user }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [icon, setIcon] = useState(null);
  const [show, setShow] = useState(false);
  const { country, countryLoading, countryError } = useSelector(
    (state) => state.GET_COUNTRY
  );

  const { state } = useSelector((state) => state.GET_STATE);
  const { city } = useSelector((state) => state.GET_CITY);
  const { language } = useSelector((state) => state.GET_LANAGUAGE);
  const { data, loading, error } = useSelector(
    (state) => state.UPDATE_PRACTITIONER
  );
  const [selectedLanguages, setSelectedLanguages] = useState([
    "Hindi",
    "English",
  ]);
  const [languageInput, setLanguageInput] = useState("");

  const onFinish = (values) => {
    console.log("Form values:", values);
    let stateName = state.filter((item) => item.name === values.state);
    let countryName = country.filter((item) => item.name === values.country);
    console.log("here===>", stateName, countryName);
    let userData;
    try {
      if (values.phoneNumber === user?.mobile) {
        userData = {
          title: values.title,
          firstName: values.firstName,
          lastName: values.lastName,
          abhaNumber: values.licenseNumber,
          counsellorRole: values.role,
          languages: values.languages.join(", "),
          country: countryName[0].name,
          state: stateName[0].name,
          pincode: values.pincode,
          city: values.city,
          address: values.address,
          about: values.aboutYourself,
        };
      } else {
        userData = {
          title: values.title,
          firstName: values.firstName,
          lastName: values.lastName,
          mobile_number: values.phoneNumber,
          abhaNumber: values.licenseNumber,
          counsellorRole: values.role,
          languages: values.languages.join(", "),
          country: countryName[0].name,
          state: stateName[0].name,
          pincode: values.pincode,
          city: values.city,
          address: values.address,
          about: values.aboutYourself,
        };
      }

      dispatch(updateProfile(userData));
    } catch (error) {
      console.log(error);
    }
  };

  const handleLanguageInputChange = (e) => {
    setLanguageInput(e.target.value);
  };

  const handleLanguageInputPressEnter = () => {
    if (languageInput && !selectedLanguages.includes(languageInput)) {
      setSelectedLanguages([...selectedLanguages, languageInput]);
    }
    setLanguageInput("");
  };

  const removeLanguage = (language) => {
    setSelectedLanguages(selectedLanguages.filter((lang) => lang !== language));
  };

  const getCountryData = () => {
    dispatch(getCountry());
  };
  const getLanguageData = () => {
    dispatch(getLanguage());
  };

  const handleCountryChange = (v) => {
    dispatch(getState(v));
  };

  const handleStateChange = (v) => {
    dispatch(getCity(v));
  };

  useEffect(() => {
    getCountryData();
    getLanguageData();
  }, []);

  useEffect(() => {
    console.log(data, loading, error);
    if (data) {
      if (data.response_message === "Success") {
        setShow(true);

        setTitle("Profile Updated Successfully");
        setDescription("Your profile changes have been saved.");
        setIcon(IMAGES.profile_success);
      } else {
        setShow(true);

        setTitle("Profile Update Failed");
        setDescription(
          `We couldn’t save your updates. Please check the fields and try again.`
        );
        setIcon(IMAGES.profile_error);
      }
    }
    if (error) {
      setShow(true);

      setTitle("Profile Update Failed");
      setDescription(error?.payload || "Something went wrong");
      setIcon(IMAGES.profile_error);
    }
  }, [data, error]);

  useEffect(() => {
    form.setFieldsValue({
      title: user?.title,
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      phoneNumber: user?.mobile,
      licenseNumber: user?.abhaNumber,
      role: user?.counsellorRole || undefined,
      languages: user?.languages?.split(",").map((lang) => lang.trim()),
      country: user?.country,
      state: user?.state,
      pincode: user?.pincode,
      city: user?.city,
      address: user?.address,
      aboutYourself: user?.about,
    });
    dispatch(getState(user?.country));
    dispatch(getCity(user?.state));
  }, []);

  console.log("city===>", state);

  return (
    <div className="max-w-6xl mx-auto p-4 bg-white">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="w-full"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Title */}
          <Form.Item label="Title" name="title" className="mb-0 ">
            <Select
              placeholder="Select"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
            >
              <Option value="MR" className="font-poppins">
                Mr.
              </Option>
              <Option value="Mrs" className="font-poppins">
                Mrs.
              </Option>
              <Option value="Ms" className="font-poppins">
                Ms.
              </Option>
              <Option value="Dr" className="font-poppins">
                Dr.
              </Option>
            </Select>
          </Form.Item>

          {/* First Name */}
          <Form.Item label="First Name" name="firstName" className="mb-0">
            <Input
              placeholder="Type here"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
            />
          </Form.Item>

          {/* Last Name */}
          <Form.Item label="Last Name" name="lastName" className="mb-0">
            <Input
              placeholder="Type here"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
            />
          </Form.Item>

          {/* Email ID */}
          <Form.Item label="Email ID" name="email" className="mb-0">
            <Input
              placeholder="xyz@example.com"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
              readOnly
            />
          </Form.Item>

          {/* Phone Number */}
          <Form.Item
            label={<span>Phone Number</span>}
            name="phoneNumber"
            rules={[{ required: true, message: "Phone number is required" }]}
            className="mb-0"
          >
            <Input
              placeholder="Type here"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
            />
          </Form.Item>

          {/* License Number/ABHA Number */}
          <Form.Item
            label="License Number/ABHA Number"
            name="licenseNumber"
            className="mb-0"
            rules={[
              {
                required: true,
                message: "License Number/ABHA number is required",
              },
            ]}
          >
            <Input
              placeholder="Type here"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
            />
          </Form.Item>

          {/* Role */}
          <Form.Item
            label="Role"
            name="role"
            rules={[{ required: true, message: "Role is required" }]}
          >
            <Select
              placeholder="Select"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
              options={[
                {
                  label: "Counsellor",
                  value: "COUNSELLOR",
                },
                {
                  label: "Coach",
                  value: "Coach",
                },
                {
                  label: "Doctor",
                  value: "Doctor",
                },
                {
                  label: "Psychologist",
                  value: "Psychologist",
                },
              ]}
            ></Select>
          </Form.Item>

          {/* Languages Spoken */}
          <Form.Item
            label={<span>Languages Spoken</span>}
            name="languages"
            rules={[{ required: true, message: "Languages are required" }]}
          >
            <Select
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal"
              mode="multiple"
              options={language.map((item) => {
                return {
                  label: item.langName,
                  value: item.langName,
                };
              })}
            />
          </Form.Item>

          {/* Country */}
          <Form.Item
            label={<span>Country</span>}
            name="country"
            rules={[{ required: true, message: "Country is required" }]}
            className="mb-0"
          >
            <Select
              placeholder="Select Country"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
              options={country.map((item) => {
                return {
                  label: item.name,
                  value: item.name,
                };
              })}
              onChange={handleCountryChange}
            ></Select>
          </Form.Item>

          {/* State */}
          <Form.Item
            label={<span>State</span>}
            name="state"
            rules={[{ required: true, message: "State is required" }]}
            className="mb-0"
          >
            <Select
              placeholder="Select State"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
              options={state.map((item) => {
                return {
                  label: item.name,
                  value: item.name,
                };
              })}
              onChange={handleStateChange}
            ></Select>
          </Form.Item>

          {/* Pincode */}
          <Form.Item
            label={<span>Pincode</span>}
            name="pincode"
            rules={[{ required: true, message: "Pincode is required" }]}
            className="mb-0"
          >
            <Input
              placeholder="Type here"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
            />
          </Form.Item>

          {/* City */}
          <Form.Item
            label={<span>City</span>}
            name="city"
            rules={[{ required: true, message: "City is required" }]}
            className="mb-0"
          >
            <Select
              placeholder="Select City"
              className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
              style={{
                border: "1px solid #CBD5E1",
                background: "#F8FAFC !important",
              }}
              options={city.map((item) => {
                return {
                  label: item.name,
                  value: item.name,
                };
              })}
            ></Select>
          </Form.Item>
        </div>

        {/* Address */}
        <Form.Item label="Address" name="address" className="mb-0">
          <TextArea
            placeholder="Type here"
            rows={4}
            className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
            style={{
              border: "1px solid #CBD5E1",
              background: "#F8FAFC !important",
            }}
          />
        </Form.Item>

        {/* About Yourself */}
        <Form.Item
          label="About Yourself"
          name="aboutYourself"
          className="mb-0"
          rules={[{ required: true, message: "About yourself is required" }]}
        >
          <TextArea
            placeholder="Type here"
            rows={4}
            className=" border border-[#CBD5E1] h-[56px] rounded-xl bg-[#F8FAFC] text-[#64748B] text-[16px] font-poppins font-normal
"
            style={{
              border: "1px solid #CBD5E1",
              background: "#F8FAFC !important",
            }}
          />
        </Form.Item>

        {/* Form Actions */}
        <div className="flex justify-end gap-4 mt-6">
          <button
            className="border border-gray-300 px-6"
            onClick={() => setEditActive(!editActive)}
            style={{
              border: "2px solid #4B61FF !important",
              fontFamily: "Poppins",
              background: "#FFFFFF",
              color: "#4B61FF",
              fontWeight: 600,
            }}
          >
            Cancel
          </button>
          <button
            type="primary"
            htmlType="submit"
            className="btn-gradient rounded-xl px-6 font-poppins"
          >
            Save
          </button>
        </div>
      </Form>
      {show && (
        <Model
          show={show}
          setShow={(v) => {
            setShow(v);
            dispatch(resetProfileUpdate());
            dispatch(getUserProfile()).then(() => {
              setEditActive(false);
            });
          }}
          title={title}
          description={description}
          icon={icon}
        />
      )}
    </div>
  );
};

export default RegistrationForm;
